import React, { Suspense, useEffect } from "react";
import { BrowserRouter as ReactRouter, Route, Routes,Navigate } from "react-router-dom";
import store from "@redux/Store";
import loadable from '@loadable/component';
import LinearProgress from "@mui/material/LinearProgress";
import PrivateRoute,{ChildRoute} from "./PrivateRoute";
import PageNotFound from "@components/common/PageNotFound";
export const NO_ROUTE_TYPES = {
  RE_ROUTE:'reroute',
  NO_ROUTE:'no_route'
}
export const setupRouteAuthentications = (routes,postLoginPath,landingPath) => {
  const state = store.getState();
  const { isLoggedIn } = state.userReducer;
  
  const authRoutes = Object.keys(routes).reduce((ar,rk)=>{
    const r = routes[rk];
    ar[rk] = {...routes[rk],isLoggedIn,isAllowed: (!r.authRequired || isLoggedIn),redirectTo: r.authRequired?landingPath.nonLogin:postLoginPath()};
    return ar;
  },{});
  //console.log('authRoutes',authRoutes);
  return {
    isLoggedIn,
    ...routes,
    ...authRoutes
  };
};

export const asyncCompnent =(componentPath,loadableComp)=> {
  const lc = loadableComp || (() => import(componentPath));
  return loadable(lc, {
  fallback: <LinearProgress />,
});
}
const NoRouteReRoute = ({isLoggedIn,landingPath})=>{
  return <Navigate to={isLoggedIn?landingPath.login:landingPath.nonLogin} replace/>
}
const  AppRouter = ({children,appRoutes,onRouteChange,postLoginRoute,landingPath,postLoginPath,noRouteType=NO_ROUTE_TYPES.NO_ROUTE})=>{
    const {isLoggedIn,DEFAULT:defaultPageRoute,...routes} = setupRouteAuthentications(appRoutes,postLoginPath,landingPath);
    const getComponent = (routeInfo)=>(routeInfo.componentPath||routeInfo.loadablComp)?asyncCompnent(routeInfo.componentPath,routeInfo.loadablComp):routeInfo.component
    const commomProps = {onRouteChange}
    const dfr = defaultPageRoute?[defaultPageRoute]:[];
    const NoRoute = noRouteType == NO_ROUTE_TYPES.RE_ROUTE?NoRouteReRoute:PageNotFound;
    return (
      <ReactRouter>
        <Suspense fallback={<LinearProgress />}>
          <Routes>
            {[...dfr,...Object.values(routes)].map((route, index) => {
              const {DEFAULT:defaultRoute,...nextedRoutes} = route.nextedRoutes || {};
              let Comp;
              let childRoutes = nextedRoutes? Object.values(nextedRoutes).map(nroute=>{
                return <Route key={route.path + index+ nroute.path} path={nroute.path} element={<ChildRoute  childComponent {...nroute.componentOpts} {...commomProps} isLoggedIn={route.isLoggedIn} path={nroute.fullPath} component={getComponent(nroute)}/>} />}
              ):[];
              defaultRoute && route.nextedRoutes && (childRoutes = [<Route index key={route.path + index+ defaultRoute.path} element={<ChildRoute  {...commomProps} isLoggedIn={route.isLoggedIn} childComponent path={defaultRoute.fullPath} component={getComponent(defaultRoute)}/>} />,...childRoutes,<Route key={route.path + index+ defaultRoute.path+'default'} path="*" element={<ChildRoute  {...commomProps} childComponent isLoggedIn={route.isLoggedIn} component={getComponent(defaultRoute)}/>} />])
              //childRoutes.length && console.log('childRoutes',childRoutes);
              return <Route
                  key={route.path + index}
                  path={route.path}
                  element={
                    <PrivateRoute
                      {...commomProps} 
                      hasChildRoutes={!!childRoutes.length}
                      authRequired={!!route.authRequired}
                      path={route.path}
                      component={getComponent(route)}
                      isLoggedIn={route.isLoggedIn}
                      redirectTo={route.redirectTo}
                      layout={route.layout}
                      layoutOpt={route.layoutOpt}
                      postLoginRoute={!!postLoginRoute}
                      componentOpts={route.componentOpts}
                    />
                  }
                >
                  {childRoutes}
                </Route>

            })}
            <Route path="*" element={<NoRoute isLoggedIn={isLoggedIn} landingPath={landingPath}/>} />
          </Routes>
        </Suspense>
        {children}
      </ReactRouter>
    );
}

export default AppRouter;